export default __webpack_public_path__ + "static/media/copy.35488c05.svg";